import React from 'react'
import './creator.css'

const Creator = () => {
  return (
    <div className='app__para app__creator'><b>Synchem Chromatography Technologies</b> &#169; All Rights Reserved - 2022 | Designed & Developed by <b className='animate-charcter'><a href="" style={{color:'var(--color-black)'}}>iamvaras</a></b> </div>
  )
}

export default Creator